import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Dimmer, Grid, Header, Modal } from "semantic-ui-react";
import { closeModal } from "../../redux/Modals/ModalActions";
import { AppPrimaryButton } from "../UI/CustomButtons";

const actions = {
  closeModal,
};


class MessageModal extends Component {
  render() {
    const { heading, message, action, actionText } = this.props;

    return (
      <div>
        <Dimmer />
        <Modal
          size="tiny"
          style={{ KhtmlBoxAlign: "center" }}
          open={true}
          closeOnEscape={false}
          closeOnDimmerClick={false}
          centered
        >
          <Header>
            <Header.Content>{heading}</Header.Content>
          </Header>
          <Modal.Content>
            <Container textAlign="center">{message}</Container>
            <br/>
            <Grid>
              <Grid.Column textAlign="center">
              {action && (
              <AppPrimaryButton
                onClick={() => {
                  action();
                }}
              >
                {actionText ?? "Click here"}
              </AppPrimaryButton>
            )}
              </Grid.Column>
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <AppPrimaryButton
              style={{ margin: "auto" }}
              onClick={() => {
                this.props.closeModal();
              }}
            >
              Okay
            </AppPrimaryButton>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default connect(null, actions)(MessageModal);
export const MODAL_CUSTOM_MESSAGE = "MessageModal";
